(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        window.optimizely = window.optimizely || [];
        window.optimizely.push("activateSiteCatalyst");
    });
})(window.nadex.marketing.analytics);